import runtime from '@hsbc/evolve-runtime';

const removeTheme = () => {
	const node = document.querySelector('body');
	if (!node) return;
	node.classList.remove('ev-theme-light');
};

runtime.onMessage('THEME_CHANGE', () => {
	removeTheme();
	setTimeout(removeTheme, 1);
});

runtime.ready().then(() => {
	runtime.keepWithinScreen();
	removeTheme();
});

document.addEventListener('DOMContentLoaded', removeTheme);
